import React from "react";
import styles from "./AIInteractions.module.css";
const AIInteractions = () => {

    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>
                Secure & Compliant AI Interactions                       </h2>
            <p>
                Handle sensitive traveler information safely while meeting <br />
                industry regulations.
            </p>
            <div className={styles.wrapper}>
                <div className={styles.featureList}>
                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>GDPR and data protection compliance</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>Secure payment and booking processes</h4>
                        </div>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.star}></span>
                        <div>
                            <h4>Reliable privacy management</h4>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AIInteractions;
